var _title, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "48.167px",
    viewBox: "0 0 50 48.167",
    enableBackground: "new 0 0 50 48.167",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Back")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.545,24.479l9.583-9.583c0.703-0.703,0.703-1.843,0-2.546s-1.842-0.702-2.545,0L25,21.934l-9.583-9.583 c-0.703-0.702-1.843-0.702-2.546,0c-0.703,0.703-0.703,1.843,0,2.546l9.583,9.583l-9.583,9.583c-0.703,0.702-0.703,1.843,0,2.545 c0.352,0.352,0.812,0.527,1.273,0.527s0.921-0.176,1.273-0.527L25,27.025l9.583,9.583c0.352,0.352,0.812,0.527,1.272,0.527 s0.921-0.176,1.272-0.527c0.703-0.702,0.703-1.843,0-2.545L27.545,24.479z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.4611e20f.svg";
export { ForwardRef as ReactComponent };